import {TPropsWithChildrenRequire} from 'core/types';
import {IPaginationContext, PaginationContext} from 'plugins/modules/pagination/context';
import React, {FC} from 'react';

interface IProps extends IPaginationContext, TPropsWithChildrenRequire {}

export const PaginationProvider: FC<IProps> = ({children, ...restPaginationContextProps}) => {
    return <PaginationContext.Provider value={restPaginationContextProps}>{children}</PaginationContext.Provider>;
};
